module.exports = [
	{
		"icon": "https://cdn.auth0.com/website/assets/pages/about/img/board-directors/trinity-1543e84f62.svg",
		"name": "Karan Mehandru",
		"title": "General Partner, Trinity Ventures ",
		"category": "Member"
	},
	{
		"icon": "https://cdn.auth0.com/website/assets/pages/about/img/board-directors/zapproved-c0728c74cb.svg",
		"name": "Monica Enand",
		"title": "CEO, Zapproved Inc.",
		"category": "Member"
	},
	{
		"icon": "https://cdn.auth0.com/website/assets/pages/about/img/board-directors/heroku-13a3bb673e.svg",
		"name": "Peter van Hardenberg",
		"title": "Principal, Ink and Switch. Head of Product, Heroku Postgres.",
		"category": "Member"
	},
	{
		"icon": "https://cdn.auth0.com/website/assets/pages/about/img/board-directors/bessemer-6493fcb241.svg",
		"name": "David Cowan",
		"title": "Partner, Bessemer Venture Partners.",
		"category": "Member"
	},
	{
		"icon": "https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.svg",
		"name": "Eugenio Pace",
		"title": "CEO & Co-founder, Auth0",
		"category": "Member"
	},
	{
		"icon": "https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.svg",
		"name": "Matias Woloski",
		"title": "CTO & Co-founder, Auth0",
		"category": "Observer"
	},
	{
		"icon": "https://cdn.auth0.com/website/assets/pages/about/img/board-directors/meritech-99f37ccb8f.svg",
		"name": "George Bischof",
		"title": "Managing Director, Meritech Ventures.",
		"category": "Observer"
	},
	{
		"icon": "https://cdn.auth0.com/website/assets/pages/about/img/board-directors/k9-d042bba074.svg",
		"name": "Manu Kumar",
		"title": "Chief Firestarter, K9 Ventures.",
		"category": "Observer"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/data/board-directors.json
// module id = 1351
// module chunks = 0